import { ApiError } from '../errors';
import AuthError from '../errors/AuthError';

export function buildRequestError(response, data) {
  if (data.trackingId) {
    return new ApiError(data, response.status);
  }

  if (response.status === 401) {
    return new AuthError(response.message, response.status);
  }

  return new ApiError(response.message, response.status);
}

export default buildRequestError;
